module.exports = __webpack_require__.p + "7cf24ddb8535c701c67f1b32ec020813.jpg";